class SizeChart extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll('[data-tab]');
    this.panels = this.querySelectorAll('[data-panel]');

    this.bindEvents();
    this.parseSizeData();
  }

  bindEvents() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => this.switchTab(e.target.dataset.tab));
    });
  }

  parseSizeData() {
    const settings = JSON.parse(this.querySelector('[data-size-chart-settings]').textContent);

    this.generateTableHeaders(settings.tableHeaders);

    if (settings.mensSizes) {
      this.populateSizeTable('[data-sizes="mens"]', settings.mensSizes, settings.tableHeaders);
    }

    if (settings.womensSizes) {
      this.populateSizeTable('[data-sizes="womens"]', settings.womensSizes, settings.tableHeaders);
    }
  }

  generateTableHeaders(headerString) {
    if (!headerString) return;

    const theads = this.querySelectorAll('[data-table-headers]');
    theads.forEach((thead) => {
      thead.innerHTML = '';

      const headerData = this.parseHeaders(headerString);

      headerData.headers.forEach((rowHeaders, rowIndex) => {
        const tr = document.createElement('tr');
        
        rowHeaders.forEach((header) => {
          const th = document.createElement('th');
          th.textContent = header.name;
          
          if (header.colspan > 1) {
            th.colSpan = header.colspan;
          }
          if (header.rowspan > 1) {
            th.rowSpan = header.rowspan;
          }
          
          if (rowIndex === 0 && header.colspan > 1) {
            th.classList.add('group-header');
          }
          
          tr.appendChild(th);
        });
        
        thead.appendChild(tr);
      });
    });
  }

  parseHeaders(headerString) {
    const parts = headerString.split('|');

    let hasGroupedHeaders = false;
    parts.forEach((part) => {
      if (part.match(/\[([^\]]+)\]\(([^)]+)\)/)) {
        hasGroupedHeaders = true;
      }
    });

    const firstRowHeaders = [];
    const secondRowHeaders = [];

    parts.forEach((part) => {
      const groupMatch = part.match(/\[([^\]]+)\]\(([^)]+)\)/);
      
      if (groupMatch) {
        const subHeaders = groupMatch[1].split(/\s*-\s*/);
        const groupName = groupMatch[2];
        
        firstRowHeaders.push({
          name: groupName,
          colspan: subHeaders.length,
          rowspan: 1
        });
        
        subHeaders.forEach(subHeader => {
          secondRowHeaders.push({
            name: subHeader.trim(),
            colspan: 1,
            rowspan: 1
          });
        });
      } else {
        firstRowHeaders.push({
          name: part.trim(),
          colspan: 1,
          rowspan: hasGroupedHeaders ? 2 : 1
        });
      }
    });

    const result = {
      headers: hasGroupedHeaders ? [firstRowHeaders, secondRowHeaders] : [firstRowHeaders]
    };

    return result;
  }

  populateSizeTable(selector, sizeData, headerString) {
    const tbody = this.querySelector(selector);
    if (!tbody || !sizeData) return;

    const headerData = this.parseHeaders(headerString || 'US|EU|UK|[Inches-CM](Heel-to-Toe)');
    
    let expectedColumns = 0;
    if (headerData.headers.length > 1) {
      headerData.headers[0].forEach(header => {
        expectedColumns += header.colspan;
      });
    } else {
      expectedColumns = headerData.headers[0].length;
    }

    const rows = sizeData.split('\n').filter((row) => row.trim());

    rows.forEach((row) => {
      const tr = document.createElement('tr');
      const sizes = row.split('-');

      for (let i = 0; i < expectedColumns; i++) {
        const td = document.createElement('td');
        td.textContent = sizes[i] ? sizes[i].trim() : '';
        td.style.width = 100 / expectedColumns + '%';
        tr.appendChild(td);
      }

      tbody.appendChild(tr);
    });
  }

  switchTab(tabName) {
    this.tabs.forEach((tab) => {
      tab.classList.toggle('active', tab.dataset.tab === tabName);
    });

    this.panels.forEach((panel) => {
      panel.classList.toggle('active', panel.dataset.panel === tabName);
    });
  }
}

customElements.define('size-chart', SizeChart);
